/**
 * 清空 popover 中生成的图片和预览
 */
function clearGeneratedImagesInPopover(popover) {

  // 1. 清空图片网格
  const imagesGrid = document.getElementById('select-image-list');
  if (imagesGrid) {
    imagesGrid.innerHTML = '';
  }

  // 2. 重置隐藏的图片 URL 输入框
  // 通过 ID 直接清空（更可靠）
  const hidden1 = popover.querySelector('#ai-custom-image-url');
  const hidden2 = popover.querySelector('#ai-custom-image-url-2');
  const display1 = popover.querySelector('#ai-custom-image-url-display');
  const display2 = popover.querySelector('#ai-custom-image-url-2-display');

  if (hidden1 && hidden1.value) {
    hidden1.value = '';
  }

  if (hidden2 && hidden2.value) {
    hidden2.value = '';
  }

  if (display1 && display1.value) {
    display1.value = '';
  }

  if (display2 && display2.value) {
    display2.value = '';
  }

  // 额外清空任何其他可能存在的 Custom Image 输入框
  const extraHiddenInputs = popover.querySelectorAll('input[name*="Custom Image"]');
  extraHiddenInputs.forEach(input => {
    if (input.value && input !== hidden1 && input !== hidden2) {
      input.value = '';
    }
  });

  // 3. 清空图片预览
  const previewImages = popover.querySelectorAll('#ai-upload-preview, #ai-upload-preview-2');
  previewImages.forEach(img => {
    if (img) {
      img.src = '';
    }
  });

  // 4. 重置上传状态文本
  const statusDivs = popover.querySelectorAll('#ai-upload-status, #ai-upload-status-2');
  statusDivs.forEach(div => {
    if (div) {
      div.textContent = '';
      div.className = 'ai-upload-status';
    }
  });

  // 5. 重置上传按钮状态
  const uploadButtons = popover.querySelectorAll('#ai-upload-trigger, #ai-upload-trigger-2');
  uploadButtons.forEach(btn => {
    if (btn) {
      btn.classList.remove('has-image', 'validation-error');
      const buttonText = btn.querySelector('.button-text, .ai-upload-text');
      if (buttonText) {
        buttonText.textContent = 'Upload Photo';
      }
    }
  });

  // 6. 重置全局上传弹窗状态（如果存在）
  if (window.globalUploadModal) {
    window.globalUploadModal.selectedImageUrl = null;
  }

}

function openPopoverUpsellWhenReady(popover) {
  if (!window.upsellPopup || !window.upsellPopup.isEnabled() || window.upsellPopup.isOpen()) return;

  const productForm = popover.querySelector('form[is="product-form"], form[id*="product-form"]');
  if (!productForm) return;

  const image1 = popover.querySelector('#ai-custom-image-url');
  const image2 = popover.querySelector('#ai-custom-image-url-2');
  const upload2 = popover.querySelector('.ai-upload-container[data-upload-index="2"], #ai-upload-trigger-2');
  const secondUploadVisible = upload2 && upload2.offsetParent !== null;

  if (!image1?.value?.trim()) return;
  if (secondUploadVisible && !image2?.value?.trim()) return;

  window.upsellPopup.openForForm(productForm);
}

// 为抽屉中的上传组件初始化 ImageUploader（移动端 popover）
function initDrawerUploaders(drawer) {

  if (typeof ImageUploader === 'undefined' || typeof window.globalUploadModal === 'undefined') {
    console.error('[Popover Upload] ImageUploader or GlobalUploadModal not loaded');
    return false; // 返回false表示初始化失败
  }

  // 初始化第一个上传器
  const trigger1 = drawer.querySelector('#ai-upload-trigger');
  const input1 = drawer.querySelector('#ai-file-input');
  const hidden1 = drawer.querySelector('#ai-custom-image-url');

  let uploader1Initialized = false;
  if (trigger1 && input1 && hidden1 && !trigger1.dataset.uploaderInitialized) {
    trigger1.dataset.uploaderInitialized = 'true';

    const uploader1 = new ImageUploader({
      // API 配置（apiBaseUrl 使用默认值）
      uploadEndpoint: '/models/createModelsFromImages',
      pollEndpoint: '/jobs/queryStatus',
      tokenStorageKey: 'deliver3d_guest_token',
      jobNum: 2,
      sourceType: 'cute_single_img2img_deliver3d_long',
      defaultStyle: 'Q-Style',
      onImageSelect: (url) => {
        const preview = drawer.querySelector('#ai-upload-preview');
        const status = drawer.querySelector('#ai-upload-status');
        if (preview) preview.src = url;
        if (trigger1) {
          trigger1.classList.add('has-image');
          trigger1.classList.remove('validation-error');
        }
        if (status) {
          status.textContent = '✓ Design selected!';
          status.className = 'ai-upload-status success';
        }
        openPopoverUpsellWhenReady(drawer);
      },
      onUploadError: (error) => {
        const status = drawer.querySelector('#ai-upload-status');
        if (status) {
          status.textContent = '✗ Upload failed: ' + error.message;
          status.className = 'ai-upload-status error';
        }
      }
    });

    // 使用元素对象而不是选择器字符串
    uploader1.init(trigger1, input1, hidden1);
    uploader1Initialized = true;

    // 删除按钮
    const removeBtn1 = drawer.querySelector('#ai-upload-remove');
    if (removeBtn1 && !removeBtn1.dataset.listenerAdded) {
      removeBtn1.dataset.listenerAdded = 'true';
      removeBtn1.addEventListener('click', (e) => {
        e.stopPropagation();
        const preview = drawer.querySelector('#ai-upload-preview');
        const status = drawer.querySelector('#ai-upload-status');
        if (preview) preview.src = '';
        if (trigger1) trigger1.classList.remove('has-image');
        if (hidden1) hidden1.value = '';
        if (status) {
          status.textContent = '';
          status.className = 'ai-upload-status';
        }
      });
    }
  } else if (!trigger1 || !input1 || !hidden1) {
    console.warn('[Popover Upload] Uploader 1 elements not found');
    return false;
  } else if (trigger1?.dataset.uploaderInitialized === 'true') {
    uploader1Initialized = true;
  }

  // 初始化第二个上传器
  const trigger2 = drawer.querySelector('#ai-upload-trigger-2');
  const input2 = drawer.querySelector('#ai-file-input-2');
  const hidden2 = drawer.querySelector('#ai-custom-image-url-2');

  let uploader2Initialized = false;
  if (trigger2 && input2 && hidden2 && !trigger2.dataset.uploaderInitialized) {
    trigger2.dataset.uploaderInitialized = 'true';

    const uploader2 = new ImageUploader({
      // API 配置（apiBaseUrl 使用默认值）
      uploadEndpoint: '/models/createModelsFromImages',
      pollEndpoint: '/jobs/queryStatus',
      tokenStorageKey: 'deliver3d_guest_token',
      jobNum: 2,
      sourceType: 'cute_single_img2img_deliver3d_long',
      defaultStyle: 'Q-Style',
      onImageSelect: (url) => {
        const preview = drawer.querySelector('#ai-upload-preview-2');
        const status = drawer.querySelector('#ai-upload-status-2');
        if (preview) preview.src = url;
        if (trigger2) {
          trigger2.classList.add('has-image');
          trigger2.classList.remove('validation-error');
        }
        if (status) {
          status.textContent = '✓ Design selected!';
          status.className = 'ai-upload-status success';
        }
        openPopoverUpsellWhenReady(drawer);
      },
      onUploadError: (error) => {
        const status = drawer.querySelector('#ai-upload-status-2');
        if (status) {
          status.textContent = '✗ Upload failed: ' + error.message;
          status.className = 'ai-upload-status error';
        }
      }
    });

    // 使用元素对象而不是选择器字符串
    uploader2.init(trigger2, input2, hidden2);
    uploader2Initialized = true;

    // 删除按钮
    const removeBtn2 = drawer.querySelector('#ai-upload-remove-2');
    if (removeBtn2 && !removeBtn2.dataset.listenerAdded) {
      removeBtn2.dataset.listenerAdded = 'true';
      removeBtn2.addEventListener('click', (e) => {
        e.stopPropagation();
        const preview = drawer.querySelector('#ai-upload-preview-2');
        const status = drawer.querySelector('#ai-upload-status-2');
        if (preview) preview.src = '';
        if (trigger2) trigger2.classList.remove('has-image');
        if (hidden2) hidden2.value = '';
        if (status) {
          status.textContent = '';
          status.className = 'ai-upload-status';
        }
      });
    }
  } else if (trigger2?.dataset.uploaderInitialized === 'true') {
    uploader2Initialized = true;
  } else {
    // 第二个上传器不存在是正常的
    uploader2Initialized = true;
  }

  const success = uploader1Initialized;
  return success;
}

// 为抽屉中的表单添加校验
function addDrawerFormValidation(form, drawer) {
  if (form.dataset.validationAdded === 'true') return;
  form.dataset.validationAdded = 'true';

  
  // The popover HTML is loaded after the main product-form script runs, so
  // buttons can keep their initial generated-image guard disabled state.
  drawer.querySelectorAll('[data-generated-image-guard-pending]').forEach(button => {
    button.removeAttribute('disabled');
    button.removeAttribute('data-generated-image-guard-pending');
  });

  // 校验函数
  function validateForm() {
    const hidden1 = drawer.querySelector('#ai-custom-image-url');
    const hidden2 = drawer.querySelector('#ai-custom-image-url-2');
    const container2 = drawer.querySelector('.ai-upload-container[data-upload-index="2"]');

    // 检查第二个上传框是否可见
    const isSecondUploaderVisible = container2 && container2.style.display !== 'none';

    const hasImage1 = hidden1 && hidden1.value.trim() !== '';
    const hasImage2 = !isSecondUploaderVisible || (hidden2 && hidden2.value.trim() !== '');

    if (!hasImage1) {
      const trigger1 = drawer.querySelector('#ai-upload-trigger');
      const status1 = drawer.querySelector('#ai-upload-status');

      if (trigger1) {
        trigger1.classList.add('validation-error');
        trigger1.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (status1) {
        status1.textContent = '';
        status1.className = 'ai-upload-status error';
      }

      return false;
    }

    if (isSecondUploaderVisible && !hasImage2) {
      const trigger2 = drawer.querySelector('#ai-upload-trigger-2');
      const status2 = drawer.querySelector('#ai-upload-status-2');

      if (trigger2) {
        trigger2.classList.add('validation-error');
        trigger2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (status2) {
        status2.textContent = '';
        status2.className = 'ai-upload-status error';
      }

      return false;
    }

    return true;
  }

  // 拦截表单提交事件（捕获阶段）
  form.addEventListener('submit', function(e) {
    if (!validateForm()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // 同时拦截冒泡阶段
  form.addEventListener('submit', function(e) {
    if (!validateForm()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, false);

  // 查找 Add to Cart 按钮并添加点击拦截
  const addToCartButtons = drawer.querySelectorAll('button[type="submit"], button[name="add"], .product-form__add-button');
  addToCartButtons.forEach(button => {
    if (button.dataset.validationListenerAdded === 'true') return;
    button.dataset.validationListenerAdded = 'true';

    // 捕获阶段拦截
    button.addEventListener('click', function(e) {
      if (!validateForm()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  });

  // 为 Shopify Payment Button 添加拦截
  const paymentButtonContainer = form.querySelector('.shopify-payment-button');
  if (paymentButtonContainer) {
    // 使用事件委托在容器上监听所有点击事件
    paymentButtonContainer.addEventListener('click', function(e) {
      if (!validateForm()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true); // 使用捕获阶段
  }
}

/**
 * Popover 中 Figure Type 切换时更新 Style swatch 图片
 */
function setupPopoverFigureTypeStyleSync(drawer) {
  if (!drawer) return;

  // 找到 "Choose Figure Type" 所在的 option-selector
  let figureTypeSelector = null;
  const optionSelectors = drawer.querySelectorAll('.product-form__option-selector');
  optionSelectors.forEach(selector => {
    const nameEl = selector.querySelector('.product-form__option-name');
    if (nameEl && nameEl.textContent.trim().toLowerCase().replace(':', '') === 'choose figure type') {
      figureTypeSelector = selector;
    }
  });

  if (!figureTypeSelector) {
    return;
  }

  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function updateStyleImages() {
    const checkedRadio = figureTypeSelector.querySelector('input[type="radio"]:checked');
    if (!checkedRadio) return;

    const figureType = handleize(checkedRadio.value);

    const styleWrappers = drawer.querySelectorAll('.block-swatch__image-wrapper[data-style-value]');

    styleWrappers.forEach(wrapper => {
      const styleValue = wrapper.getAttribute('data-style-value');
      const attrName = 'data-img-' + figureType;
      const newSrc = wrapper.getAttribute(attrName);

      if (newSrc) {
        let img = wrapper.querySelector('img.block-swatch__image');
        if (!img) {
          img = document.createElement('img');
          img.className = 'block-swatch__image';
          img.loading = 'lazy';
          img.alt = styleValue || '';
          wrapper.appendChild(img);
        }
        img.src = newSrc;
        img.srcset = '';
      }
    });
  }

  // 监听 figure type radio 变化
  const figureRadios = figureTypeSelector.querySelectorAll('input[type="radio"]');
  figureRadios.forEach(radio => {
    radio.addEventListener('change', updateStyleImages);
  });

  // 初始化时执行一次
  updateStyleImages();
}

window.addEventListener('DOMContentLoaded', function() {
  /* color-swatch__item 的显示效果 */
  $('.product-item-meta__swatch-list .color-swatch.more').on('click', function(){
      $(this).hide();
      $(this).parents('.product-item-meta__swatch-list').find('.color-swatch').removeClass('hidden');
  });

  // 防止抽屉在上传过程中被关闭
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const drawer = mutation.target;
        const isOpen = drawer.hasAttribute('open');
        const uploadInProgress = drawer.dataset.uploadInProgress;
        const modalOpen = drawer.dataset.modalOpen;

        // 如果抽屉正在关闭，但有模态框打开或上传在进行中，重新打开它
        if (!isOpen && (modalOpen === 'true' || uploadInProgress === 'true')) {
          setTimeout(() => {
            drawer.setAttribute('open', '');
          }, 0);
        }
      }
    });
  });

  // 观察所有 quick-buy-popover 元素
  document.querySelectorAll('quick-buy-popover').forEach((drawer) => {
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  });

  // 为动态添加的 popover 设置观察
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-BUY-POPOVER') {  // 修复：应该是 POPOVER 而不是 DRAWER
          observer.observe(node, { attributes: true, attributeFilter: ['open'] });
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // 监听快速购买抽屉中的变体切换
  setInterval(() => {
    const openDrawers = document.querySelectorAll('quick-buy-popover[open]');

    if (openDrawers.length > 0) {
      openDrawers.forEach((drawer) => {
        const drawerForm = drawer.querySelector('form[id*="product-form"]');

        if (drawerForm && drawerForm.dataset.drawerVariantInitialized !== 'true') {
          // 检查关键元素是否已加载
          const uploadTrigger = drawer.querySelector('#ai-upload-trigger');
          const variantIdInput = drawerForm.querySelector('input[name="id"]');

          // 只有当关键元素都存在时才标记为已初始化
          if (!uploadTrigger || !variantIdInput) {
            return; // 等待下一个interval周期
          }

          drawerForm.dataset.drawerVariantInitialized = 'true';

          // 初始化抽屉中的上传组件（带重试机制）
          const initSuccess = initDrawerUploaders(drawer);
          if (!initSuccess) {
            console.warn('[Popover Init] Uploader initialization failed, will retry');
            drawerForm.dataset.drawerVariantInitialized = 'false'; // 重置标记，允许重试
            return;
          }

          // 添加表单校验
          addDrawerFormValidation(drawerForm, drawer);

          // 设置 Figure Type → Style 图片同步
          setupPopoverFigureTypeStyleSync(drawer);

          // 获取变体元字段数据 - 使用 class 选择器因为 ID 现在是唯一的
          const metafieldScript = drawer.querySelector('.variant-metafields-data');
          let variantMetafields = {};

          if (metafieldScript) {
            try {
              const data = JSON.parse(metafieldScript.textContent);
              variantMetafields = data.variantMetafields || {};
            } catch (e) {
              console.error('[Quick Buy Drawer] Failed to parse metafield data:', e);
            }
          }

          // 监听变体切换
          // variantIdInput 已经在前面声明过了（第319行），这里直接使用
          if (!variantIdInput) return;

          // 用于跟踪之前的所有样式相关选项的状态
          let previousStyleState = null;
          let styleOptionPositions = []; // 存储所有样式相关选项的位置
          let styleRadioListenersAdded = false;

          // 检查并切换上传框显示
          function checkAndToggleUploader() {
            const currentVariantId = variantIdInput.value;

            // 尝试找到所有样式相关选项（只在第一次运行时查找）
            if (styleOptionPositions.length === 0) {

              // 方法1: 查找带有样式相关文本的 label 或 legend
              const allLabels = drawer.querySelectorAll('label, legend, .product-form__option-name, [class*="option"], [class*="label"]');

              allLabels.forEach((el, index) => {
                const text = el.textContent.trim().toLowerCase();

                // 检查是否是样式相关选项
                const isStyleOption =
                  text.includes('choose your style') ||
                  text.includes('choose figure type') ||
                  text === 'style' ||
                  text === 'choose style';

                if (isStyleOption) {
                  // 找到包含这个 label 的选项组，确定是哪个 option
                  let currentEl = el;
                  while (currentEl && currentEl !== drawer) {
                    // 查找同级或父级的 radio buttons
                    const nearbyRadios = currentEl.querySelectorAll('input[type="radio"][name^="option"]');
                    if (nearbyRadios.length > 0) {
                      const radioName = nearbyRadios[0].name; // 例如 "option2"
                      const match = radioName.match(/option(\d+)/);
                      if (match) {
                        const position = parseInt(match[1]);
                        // 避免重复添加
                        if (!styleOptionPositions.includes(position)) {
                          styleOptionPositions.push(position);
                        }
                        break;
                      }
                    }
                    currentEl = currentEl.parentElement;
                  }
                }
              });

              // 方法2: 如果上面没找到，尝试通过值来识别样式选项
              if (styleOptionPositions.length === 0) {
                for (let i = 1; i <= 3; i++) {
                  const radios = drawer.querySelectorAll(`input[name="option${i}"]`);
                  if (radios.length > 0) {
                    const values = Array.from(radios).map(r => r.value.toLowerCase());
                    const hasStyleValue = values.some(v =>
                      v.includes('person') ||
                      v.includes('people') ||
                      v.includes('pet') ||
                      v.includes('chibi') ||
                      v.includes('pixar') ||
                      v.includes('minecraft') ||
                      v.includes('funko') ||
                      v.includes('realistic')
                    );
                    if (hasStyleValue && !styleOptionPositions.includes(i)) {
                      styleOptionPositions.push(i);
                    }
                  }
                }
              }

            }

            // 获取当前所有样式选项的状态
            const currentStyleState = {};
            if (styleOptionPositions.length > 0) {
              styleOptionPositions.forEach(position => {
                const styleRadio = drawer.querySelector(`input[name="option${position}"]:checked`);
                const value = styleRadio?.value || null;
                currentStyleState[`option${position}`] = value;
              });

              // 为所有样式选项的 radio 按钮添加事件监听器（只添加一次）
              if (!styleRadioListenersAdded) {
                styleOptionPositions.forEach(position => {
                  const allStyleRadios = drawer.querySelectorAll(`input[name="option${position}"]`);

                  allStyleRadios.forEach(radio => {
                    radio.addEventListener('change', () => {
                      setTimeout(checkAndToggleUploader, 100);
                    });
                  });
                });
                styleRadioListenersAdded = true;
              }
            }


            // 检测任何样式选项的变化并清空生成的图片
            if (previousStyleState !== null && Object.keys(currentStyleState).length > 0) {
              let hasChanged = false;
              const changes = [];

              // 检查每个样式选项是否发生变化
              for (const optionKey in currentStyleState) {
                if (currentStyleState[optionKey] !== previousStyleState[optionKey]) {
                  hasChanged = true;
                  changes.push(`${optionKey}: ${previousStyleState[optionKey]} → ${currentStyleState[optionKey]}`);
                }
              }

              // 检查是否有选项被移除
              for (const optionKey in previousStyleState) {
                if (!(optionKey in currentStyleState)) {
                  hasChanged = true;
                  changes.push(`${optionKey}: removed`);
                }
              }

              if (hasChanged) {
                clearGeneratedImagesInPopover(drawer);
              }
            }

            // 更新状态（深拷贝）
            if (Object.keys(currentStyleState).length > 0) {
              previousStyleState = { ...currentStyleState };
            }

            // 切换第二个上传框的显示
            if (variantMetafields[currentVariantId]) {
              const isdouble = variantMetafields[currentVariantId].isdouble;
              const shouldShow = (isdouble === 'yes');

              const container2 = drawer.querySelector('.ai-upload-container[data-upload-index="2"]');
              if (container2) {
                container2.style.display = shouldShow ? 'flex' : 'none';
                const col2 = container2.closest('.ai-upload-col');
                if (col2) col2.style.display = shouldShow ? 'block' : 'none';

                // 如果隐藏第二个上传框，清空其数据，防止残留值被提交到购物车
                if (!shouldShow) {
                  const hiddenInput2 = drawer.querySelector('#ai-custom-image-url-2');
                  const displayInput2 = drawer.querySelector('#ai-custom-image-url-2-display');
                  const uploadBtn2 = drawer.querySelector('#ai-upload-trigger-2');
                  const previewImg2 = drawer.querySelector('#ai-upload-preview-2');
                  const statusDiv2 = drawer.querySelector('#ai-upload-status-2');

                  if (hiddenInput2) hiddenInput2.value = '';
                  if (displayInput2) displayInput2.value = '';
                  if (uploadBtn2) {
                    uploadBtn2.classList.remove('has-image', 'validation-error');
                    const buttonText = uploadBtn2.querySelector('.button-text, .ai-upload-text');
                    if (buttonText) buttonText.textContent = 'Upload Photo';
                  }
                  if (previewImg2) previewImg2.src = '';
                  if (statusDiv2) {
                    statusDiv2.textContent = '';
                    statusDiv2.className = 'ai-upload-status';
                  }
                }
              }
            }
          }

          // 初始检查
          checkAndToggleUploader();

          // 监听 input value 变化
          const observer = new MutationObserver(() => {
            checkAndToggleUploader();
          });

          observer.observe(variantIdInput, {
            attributes: true,
            attributeFilter: ['value']
          });

          // 轮询作为后备方案
          let lastVariantId = variantIdInput.value;
          setInterval(() => {
            const currentVariantId = variantIdInput.value;
            if (currentVariantId !== lastVariantId) {
              lastVariantId = currentVariantId;
              checkAndToggleUploader();
            }
          }, 500);
        }
      });
    }
  }, 500);
});
